import { format } from 'date-fns'

import {
  enUS as enDateFormat,
  fr as frDateFormat,
  it as itDateFormat,
  de as deDateFormat,
  zhCN as zhCnDateFormat,
  zhTW as zhTwDateFormat,
  ja as jpnDateFormat,
  ko as krDateFormat,
  ptBR as ptBrDateFormat,
  ru as ruDateFormat,
  es as esDateFormat,
} from 'date-fns/locale'

const dateLocaleMatrix = {
  en: enDateFormat,
  fr: frDateFormat,
  it: itDateFormat,
  de: deDateFormat,
  'zh-Hans': zhCnDateFormat,
  'zh-Hant': zhTwDateFormat,
  ja: jpnDateFormat,
  ko: krDateFormat,
  'pt-BR': ptBrDateFormat,
  ru: ruDateFormat,
  es: esDateFormat,
}

type TypeDateLocales = keyof typeof dateLocaleMatrix

const getDateLocale = (locale: string) => {
  return dateLocaleMatrix[locale as TypeDateLocales]
}

const formatLocalizedDate = (date: string, pattern: string, locale: string) => {
  if (!date) return ''

  const parsedDate = new Date(date)
  if (Number.isNaN(parsedDate.getTime())) return ''

  return format(parsedDate, pattern, {
    locale: getDateLocale(locale),
  })
}

export { formatLocalizedDate, getDateLocale }
